const overlayElementAttrib = "js-loading-overlay";
const overlayTriggerAttrib = "js-loading-overlay-trigger";

export const loadingOverlay = () => {
    const overlay = document.querySelector(`[${overlayElementAttrib}]`);
    const htmlRoot = document.querySelector("html");

    if (overlay && htmlRoot) {
        const triggerSources = document.querySelectorAll(`[${overlayTriggerAttrib}]`);

        const showOverlayElement = () => {
            htmlRoot.classList.add("overflow--hidden");
            
            overlay.classList.remove("display--n");
            overlay.classList.add("flex");
        };

        triggerSources.forEach((target) => {
            const eventTrigger = target.getAttribute(overlayTriggerAttrib);

            if (eventTrigger) {
                target.addEventListener(eventTrigger, () => {
                    let showOverlay = true;
                    
                    if (target.tagName.toLowerCase() === "form" && 
                        eventTrigger.toLowerCase() === "submit") {
                        // attempt to check for validation errors before showing the overlay
                        showOverlay = $(target).valid();
                    }

                    if (showOverlay) {
                        showOverlayElement();

                        const asteriskAnims = overlay.querySelectorAll("[js-staycity-asterisks]");

                        if (asteriskAnims.length) {
                            window.setInterval(() => {
                                asteriskAnims.forEach(updateAsteriskAnim);
                            }, 250);
                        }
                    }
                })
            }
        });

        const updateAsteriskAnim = (animContainer) => {
            // get all available asterisk elements
            const allAsterisks = animContainer
                .querySelectorAll("svg");
            const allAsteriskElts = [...allAsterisks];

            // find the currently-shown asterisk
            const currentAsterisk = allAsteriskElts
                .find(asterisk => !asterisk.classList.contains("display--n"));

            // select the next asterisk
            const nextAsterisks = allAsteriskElts
                .filter(asterisk => asterisk != currentAsterisk);
            const nextElt = nextAsterisks[
                Math.floor(Math.random() * nextAsterisks.length)
            ];

            // update display attributes of current and next asterisks
            currentAsterisk.classList.add("display--n");

            nextElt.classList.remove("display--n");            
        };
    }
}